export const ChartDataConstants = {
  defaultNullValueBehavior: 'gap' as const,
}
